import { Box } from "@mui/material";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import logo from "../../../assets/carrossel/logo.jpeg";

export default function EditorMenuContainer(props: { children: JSX.Element }) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
    fade: true,
  };

  const banners = [
    { id: 1, src: logo, alt: "Logo Pimaco" },
    { id: 2, src: logo, alt: "Logo Pimaco" },
    { id: 3, src: logo, alt: "Logo Pimaco" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box className="editor-menu" key="editor-menu">
        {props.children}
      </Box>
      <Box
        className="carrossel-container"
        sx={{
          width: "99vw",
          maxWidth: "100%",
          overflow: "hidden",
          display: "block",
          justifyContent: "center",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        <Slider {...settings}>
          {banners.map((item) => (
            <Box
              key={item.id}
              sx={{
                width: "99vw",
                height: "150px",
                display: "flex !important",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                src={item.src}
                alt={item.alt}
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
}
